export function relative(url: string) {
    const link = new URL(url)
    return `${link.pathname}${link.search}`
}
